import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { checkPasswordCriteria } from "../../util/passwordValidation";
import { language } from "../../languageProvider/language/language";
import { defaultLanguage } from "../../helper/utility";
import "./PasswordCriteria.css";

const CriteriaItem = ({ met, label }) => (
  <li className={`criteria-item ${met ? "criteria-met" : "criteria-unmet"}`}>
    <FontAwesomeIcon icon={met ? faCheck : faTimes} className="criteria-icon" />
    <span>{label}</span>
  </li>
);

const PasswordCriteria = ({ password }) => {
  const criteria = checkPasswordCriteria(password || "");

  return (
    <ul className="password-criteria-list">
      <CriteriaItem
        met={criteria.minLength}
        label={language[defaultLanguage].password_min_length}
      />
      <CriteriaItem
        met={criteria.hasUppercase}
        label={language[defaultLanguage].password_uppercase}
      />
      <CriteriaItem
        met={criteria.hasLowercase}
        label={language[defaultLanguage].password_lowercase}
      />
      <CriteriaItem
        met={criteria.hasNumber}
        label={language[defaultLanguage].password_number}
      />
      <CriteriaItem
        met={criteria.hasSpecialChar}
        label={language[defaultLanguage].password_special_char}
      />
    </ul>
  );
};

export default PasswordCriteria;
